import React from "react";
import { useTranslation } from "react-i18next";

const PageNotAccess = () => {
  const { t } = useTranslation();
  return (
    <div>
      {t(
        "You don't have access to this page. Please contact GemFind at support@gemfind.com"
      )}
    </div>
  );
};

export default PageNotAccess;
